export default function Accordion () {
    const ACCORDION = new Accordions()
    ACCORDION.init()
}

class Accordions {
    init() {
        this.accordionItems = document.querySelectorAll('.accordion-item')
        this.accordionTitles = document.querySelectorAll('.accordion-item-title')
        this.openClass = 'open'

        if (this.accordionTitles.length) {
            this.addEventListeners()
        }
    }

    addEventListeners () {
        for (let i = 0; i < this.accordionTitles.length; i++) {
            const TRIGGER = this.accordionTitles[i]
            const PARENT = TRIGGER.parentNode

            TRIGGER.addEventListener('click', () => {
                if (PARENT.classList.contains(this.openClass) === false) {
                    this.closeAllAccordions()
                    PARENT.classList.add(this.openClass)
                } else {
                    PARENT.classList.remove(this.openClass)
                }
            })
        }
    }

    closeAllAccordions () {
        for (let i = 0; i < this.accordionItems.length; i++) {
            const ITEM = this.accordionItems[i]
            ITEM.classList.remove(this.openClass)
        }
    }

}